<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>

        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
               <v-icon large >business</v-icon>
                <div class="fullname" >{{ entityName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab-item>
                   <div class="content">
                      <div class="content-left">
                        <v-text-field v-model="entityName" :label="$t('message.Name')"></v-text-field>
                        <label>{{ $t('message.Description')}}</label>
                        <textarea v-model="entityDescription" ></textarea>
                      </div>
                      <div class="sidebar-right">
                        <v-autocomplete  v-model="projectId" :items="projects" :loading="isLoading" :search-input.sync="search" item-text="name" item-value="projectId" :label="$t('message.Project')" ></v-autocomplete>
                        <v-menu ref="menuStart" :close-on-content-click="false" v-model="menuStart" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <v-text-field slot="activator" v-model="startDate" :label="$t('message.StartDate')" prepend-icon="event" readonly ></v-text-field>
                            <v-date-picker v-model="startDate" no-title scrollable  @input="menuStart = false" ></v-date-picker>
                        </v-menu>
                        <v-menu ref="menu" :close-on-content-click="false" v-model="menu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <v-text-field slot="activator" v-model="dueDate" :label="$t('message.DueDate')" prepend-icon="event" readonly ></v-text-field>
                            <v-date-picker v-model="dueDate" no-title scrollable  @input="menu = false" ></v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                </v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import SprintRepository from "../../services/SprintRepository.js";
import ProjectRepository from "../../services/ProjectRepository.js";

import HAL from "../../helpers/HAL.js";

export default {
  name: "SprintPage",
  computed: {
    computedPageHeight: function() {
      return this.pageHeight + "px";
    }
  },
  data() {
    return {
      pageHeight: 10,
      entityName: "",
      entityDescription: "",
      startDate: null,
      dueDate: null,
      sprintId: null,
      projectId: null,
      updateLink: null,
      insertLink: "/api/sprints",
      backLink: "/sprint-list",
      menu: false,
      menuStart: false,
      projects: [],
      isLoading: false,
      search: null,
      showmessage: false,
      alertMessage: ''
    };
  },
  methods: {
    goBack() {
      return "/sprint-list";
    },
    save() {
      var entity = {
        sprintId: this.sprintId,
        description: this.entityDescription,
        name: this.entityName,
        startDate: this.startDate,
        dueDate: this.dueDate,
        projectId: this.projectId
      };
      if (entity.sprintId > 0) {
        GenericRepository.update(this.updateLink.href, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      } else {
        GenericRepository.insert(this.insertLink, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      }
    }
  },
  created() {
    this.pageHeight = window.innerHeight - 57 - 25 - 25;
    if (!isNaN(this.$route.params.id)) {
      SprintRepository.getByID(this.$route.params.id).then(
        function(response) {
          if (response.data && response.data.status == "Success") {
            this.entityName = response.data.name;
            this.entityDescription = response.data.description;
            this.sprintId = response.data.sprintId;
            this.projects = [
              {
                projectId: response.data.projectId,
                name: response.data.projectName
              }
            ];
            this.projectId = response.data.projectId;
            this.startDate = this.$moment(response.data.startDate).format(
              "YYYY-MM-DD"
            );
            this.dueDate = this.$moment(response.data.dueDate).format(
              "YYYY-MM-DD"
            );
            this.updateLink = HAL.getLink(response.data, "help:sprint-update");
          }
        }.bind(this)
      );
    }
  },
  watch: {
    search(value) {
      if (!value || value.length < 3) return;

      if (this.isLoading) return;

      this.isLoading = true;

      ProjectRepository.search(value)
        .then(response => {
          this.projects = HAL.getEmbededResources(
            response.data,
            "help:project"
          );
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style lang="stylus">
@import '../../assets/css/tool-bar.css';
@import '../../assets/css/entity-page.css';
</style>
